import { render } from "./SubscriptionNotices.vue?vue&type=template&id=35124880"
import script from "./SubscriptionNotices.vue?vue&type=script&lang=js"
export * from "./SubscriptionNotices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__